module.exports = __webpack_public_path__ + "img/stormers-logo-icon.a4a83b78.png";